import { ETH, HOLESKY, SEPOLIA } from '@/utils/networks/types';

const SUPPORTED_NETWORKS = [ETH, HOLESKY, SEPOLIA];

export { SUPPORTED_NETWORKS };
